const { VITE_COOKIE_TOKEN_NAME, VITE_COOKIE_USER_NAME } = import.meta.env

export const COOKIE_TOKEN_NAME = VITE_COOKIE_TOKEN_NAME as string
export const COOKIE_USER_NAME = VITE_COOKIE_USER_NAME as string
export const COOKIE_ACCESS_TOKEN = `${COOKIE_TOKEN_NAME}-access_token`
export const COOKIE_REFRESH_TOKEN = `${COOKIE_TOKEN_NAME}-refresh_token`
